module.exports = __webpack_public_path__ + "92a8b6428fb58cd4d1aed5a4451e14f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/programs.png
// module id = 264
// module chunks = 1